import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { InvestigationWorkNoteEntity } from '../../../domain/entities/investigation-work-note.entity';

export interface GetInvestigationWorkNotesQuery { investigationId: string; }
export interface GetInvestigationWorkNotesResult { workNotes: InvestigationWorkNoteEntity[]; }

@Injectable({ providedIn: 'root' })
export class GetInvestigationWorkNotesUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetInvestigationWorkNotesQuery): Observable<GetInvestigationWorkNotesResult> {
    this._state.setLoadingWorkNotes(true);
    this._state.setErrorWorkNotes(null);
    return this._repository.getWorkNotes(query.investigationId).pipe(
      tap((workNotes) => {
        this._state.setWorkNotes(workNotes);
        this._state.setLoadingWorkNotes(false);
      }),
      map((workNotes) => ({ workNotes })),
      catchError((error) => {
        this._state.setErrorWorkNotes(error.message || 'Failed to get work notes');
        this._state.setLoadingWorkNotes(false);
        return throwError(() => error);
      }),
    );
  }
}
